import XFormPropView from './xFormPropView.vue';

export const name = 'x-form';

export const createFormDesignSettingFormConfig = () => {
    return {
        name: '表单名称2',
        mobileTitleAlign: 'right',
        mobileTitleBold: true,
        mobileTitleColon: true,
        mobileTitleWidth: 100,
        mobileVertical: true,
        pcTitleAlign: 'right',
        pcTitleBold: false,
        pcTitleColon: true,
        pcTitleWidth: '100',
        pcTitleWidthUnit: '',
        showMobile: false,
        showPc: true,
        size: 'mini', // 尺寸
        span: 12, // 所有项占的格数，总24格
        align: 'left', // 内容水平对齐方式
        verticalAlign: 'center', // 内容垂直对齐方式
        border: false, // 显示边框
        titleBackground: false, // 标题显示背景色
        titleAlign: 'right', // 所有项目的标题对齐方式
        titleWidth: '100%', // 所有项目的标题宽度
        titleColon: true, // 显示冒号
        titleAsterisk: true, // 显示必填项的红色星号
        titleOverflow: true, // 标题内容超出宽度时是否显示省略号
        padding: true, // 显示边距
        vertical: false, // 所有项使用垂直布局
        readonly: false, // 表单是否只读
        disabled: false, // 表单是否禁用
        showTitle: true, // 是否显示标题
        validConfig: {
            autoPos: true, // 是否自动定位到校验不通过的项
            theme: 'simple', // 校验主题样式,simple（简化样式），bright（高亮样式）
            showMessage: true, // 是否显示错误信息
        },
    };
};

export const renderFormDesignSettingFormView = (renderOpts = {}, { $formDesign } = {}) => {
    if (!$formDesign) return null;
    const { getConfig, getFormData } = $formDesign;
    const { formConfig } = getConfig();
    const formData = getFormData();
    console.log('renderFormDesignSettingFormView:', formConfig, ', formData:', formData);
    const handleFormConfigChanged = (val) => {
        const { showPc, showMobile, name } = val || {};
        const newConfig = { formConfig: { ...val, title: name, pcVisible: showPc, mobileVisible: showMobile } };
        console.log('=== new config:', newConfig);
        $formDesign.loadConfig(newConfig);
    };
    return <XFormPropView model={formConfig} onUpdate:model={handleFormConfigChanged} />;
};

export const renderFormDesignWidgetPreview = ({ name } = {}, { widget, isEditMode, isViewMode, $formDesign, $formView } = {}) => {
    console.log('renderFormDesignWidgetPreview:', name, ', isViewMode:', isViewMode);
    return <div>这是PC端表单控件预览</div>;
};

export const renderFormDesignWidgetMobilePreview = ({ name } = {}, { widget, isEditMode, isViewMode, $formDesign }) => {
    console.log('renderFormDesignWidgetMobilePreview:', name, ', isViewMode:', isViewMode);
    return <div>这是移动端表单控件预览</div>;
};

// renderFormDesignStyleFormView pc端预览样式设置
export const renderFormDesignStyleFormView = (renderOpts = {}, { formConfig, $formDesign } = {}) => {
    console.log('renderFormDesignStyleFormView: formConfig:', formConfig);
    console.log('designer:', $formDesign);
    return <div>这是PC端样式设置面板</div>;
};

export const createFormViewFormConfig = ({ viewRender, formConfig } = {}) => {
    console.log('createFormViewFormConfig: viewRender:', viewRender, ', formConfig:', formConfig);
    return {
        viewRender,
        formConfig,
    };
};

export const renderFormDesignMobileStyleFormView = (renderOpts = {}, { formConfig, $formDesign } = {}) => {
    console.log('renderFormDesignMobileStyleFormView: formConfig:', formConfig);
    return <div>这是移动端样式设置面板</div>;
};
